const DateRanges = [
  { display: "Today", value: 1 },
  { display: "Weekly", value: 7 },
  { display: "Monthly", value: 30 },
];

export default DateRanges;
